import {
  GoAAppHeader,
  GoAAppHeaderMenu
} from "@abgov/react-components";
import * as React from "react";
import { useAuth } from "react-oidc-context";
import { parseToken } from "../utils/tokens";

interface IAppHeaderProps { }

const AppHeader: React.FunctionComponent<IAppHeaderProps> = (props) => {
   
  //const [username, setUsername] = useState("");

  const url = "";
  const auth = useAuth();
  
  const logout = () => {
    if (!auth.isLoading && auth.isAuthenticated) {
      auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
    }
  };

  return (
    <>
      <GoAAppHeader
        url={url}
        heading="Resource Orders"
      >
   

        <div className="header-menu">
          {auth.isAuthenticated && (
            <>
              <GoAAppHeaderMenu
                heading={parseToken(auth.user?.id_token as string)?.email}
                leadingIcon="person-circle"
              >
                {
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a onClick={logout}>Log out</a>
                }
              </GoAAppHeaderMenu>
            </>
          )}
        </div>
      </GoAAppHeader>
    </>
  );
};

export default AppHeader;
